import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

import useTransferMode from "../../../hook/useTransferMode";
import CreditPage from "../../../utils/credit/credit_page";
import VipOpenPage from "../../../utils/credit/vip_open_page";
import MiniCard from "../../Vip/components/miniCard";
import NowGame from "./nowGame";
const LevelDetail = () => {
  const { t } = useTranslation();
  const i18n_rewards = (key) => t(`reward.${key}`);

  const isTransferMode = useTransferMode();

  const textColor = useColorModeValue("dark.100", "light.100");

  return (
    <Flex direction={`column`} gap="10px">
      <NowGame />
      <CreditPage>
        <VipOpenPage>
          <Text color={textColor} as="p">
            {i18n_rewards("My Vip")}
          </Text>
          <MiniCard />
        </VipOpenPage>
      </CreditPage>
    </Flex>
  );
};

export default LevelDetail;
